import React from "react";
import { toast } from "react-toastify";
import DialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";

import { etsyRequestAuthorizationCode } from "src/apiService/modules/etsy";
import { useLoadingBackdrop } from "src/contexts/LoadingBackdropContext";
import { AddNewSalePlatformIntegrationButton } from "src/components/AddNewSalePlatformIntegrationDialog";

import Step from "../../Step";
import DialogTitle from "../../DialogTitle";

interface EtsyAddNewEtsyIntegrationProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
}

function EtsyAddNewEtsyStore({
  onClose,
  onStepChange,
}: EtsyAddNewEtsyIntegrationProps) {
  const backdrop = useLoadingBackdrop();

  return (
    <>
      <DialogTitle onClose={onClose}>Connect to Etsy</DialogTitle>
      <MuiDialogContent>
        <DialogContentText>
          Click connect to be taken to Etsy's website to authenticate. Please
          follow the prompts in order to connect your Etsy account.
        </DialogContentText>
      </MuiDialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onStepChange("etsy:do-you-sell-on-etsy");
          }}
          color="primary"
          autoFocus
        >
          Go Back
        </Button>
        <AddNewSalePlatformIntegrationButton
          variant="contained"
          color="primary"
          onConnect={async (bankAccountId) => {
            try {
              const authResponse = await etsyRequestAuthorizationCode({
                back: "/get-started#other:do-you-sell",
                bankAccountId,
              });
              backdrop.current.show();
              window.location.href = authResponse.data.etsyURL;
            } catch (e) {
              toast.error(`There was an error: ${(e as Error).toString()}`);
            }
          }}
        >
          Connect
        </AddNewSalePlatformIntegrationButton>
      </DialogActions>
    </>
  );
}

export default EtsyAddNewEtsyStore;
